<template>
    <section id="form_section">
        <Toast />

        <div class="breadcrumb_container">
            <Breadcrumb :unstyled="true" :home="{icon: 'pi pi-home', route: '/'}" :model="breadcrumbs">
                <template #item="{ item }">
                    <Link v-if="item.route" :href="item.route">
                        <span :class="[item.icon, 'text-color']" />
                        <span class="text-primary font-semibold">{{ item.label }}</span>
                    </Link>
                    <span v-else class="font-semibold">{{ item.label }}</span>
                </template>
            </Breadcrumb>
        </div>

        <div class="container">
            <div class="service_header">
                <h1 class="service_title">Підбір жорсткої шини</h1>
            </div>

            <div class="content_tabs main">

                <div class="tab_content_item mobile">
                    <div class="input_groups">
                        <img v-if="!data.material" src="/img/kalkulyator-pidboru-zhorstkoyi-shini.svg" class="trans_img" alt="image">
                        <img v-if="data.material && data.material === 'Алюміній'" src="/img/AL_busbar_300.png" class="trans_img" alt="image">
                        <img v-if="data.material && data.material === 'Мідь'" src="/img/Cu_busbar_300.png" class="trans_img" alt="image">
                    </div>
                </div>

                <div class="top_panel">
                    <div class="tabs">
                        <div class="content_tab content_tab-item" :class="{'active': activeTab === 0}" @click.prevent="selectTab(0)">
                            <span>За силою струму</span>
                        </div>
                        <div class="content_tab content_tab-item" :class="{'active': activeTab === 1}" @click.prevent="selectTab(1)">
                            <span>За розмірами шини</span>
                        </div>
                    </div>
                </div>

                <div class="tab_content">
                    <div class="tab_content_item left">
                        <div class="input_groups" v-if="activeTab === 0">
                            <div class="input_group">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">Сила струму, А *</span>
                                    <div class="input_row">
                                        <input class="form_input" :placeholder="'від ' + min_power + ' до ' + max_power" type="number" min="0" v-model="data.power" v-on:input="changeValue()">
                                    </div>
                                </div>
                                <div class="tab_content_item_form_input desctop">
                                    <a class="view_spec_btn" v-on:click="getProducts()" v-if="data.material && data.power">Підібрати</a>
                                    <a class="view_spec_btn disabled" disabled v-else>Підібрати</a>
                                </div>
                            </div>
                            <div class="input_group">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">Тип металу *</span>
                                    <div class="input_row">
                                        <select class="form_select" v-model="data.material" v-on:change="() => {data.power = null; changeValue()}">
                                            <option :value="null" disabled>Обрати</option>
                                            <option v-for="(n, i) in materials" :key="`value_${i}`" :value="n">{{ n }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="input_groups" v-if="activeTab === 1">
                            <div class="input_group">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">
                                        Ширина, мм *
                                        <svg class="close_modal" v-if="data.width" @click="() => {data.width = null; changeSizeValue()}" width="11" height="11" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                                        </svg>
                                    </span>
                                    <div class="input_row">
                                        <select class="form_select" v-model="data.width" v-on:change="changeSizeValue()">
                                            <option :value="null" disabled>Обрати</option>
                                            <option v-for="(n, i) in widths" :key="`value_${i}`" :value="n">{{ n }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="input_group">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">
                                        Товщина, мм *
                                        <svg class="close_modal" v-if="data.thickness" @click="() => {data.thickness = null; changeSizeValue()}" width="11" height="11" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                                        </svg>
                                    </span>
                                    <div class="input_row">
                                        <select class="form_select" v-model="data.thickness" v-on:change="changeSizeValue()">
                                            <option :value="null" disabled>Обрати</option>
                                            <option v-for="(n, i) in thickneses" :key="`value_${i}`" :value="n">{{ n }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input_groups" v-if="activeTab === 1">
                            <div class="input_group">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">
                                        Довжина, мм *
                                        <svg class="close_modal" v-if="data.dovzhina" @click="() => {data.dovzhina = null; changeSizeValue()}" width="11" height="11" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                                        </svg>
                                    </span>
                                    <div class="input_row">
                                        <select class="form_select" v-model="data.dovzhina" v-on:change="changeSizeValue()">
                                            <option :value="null" disabled>Обрати</option>
                                            <option v-for="(n, i) in dovzhini" :key="`value_${i}`" :value="n">{{ n }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="tab_content_item_form_input desctop">
                                    <a class="view_spec_btn" v-on:click="getProducts()" v-if="data.material && data.width && data.thickness && data.dovzhina">Підібрати</a>
                                    <a class="view_spec_btn disabled" disabled v-else>Підібрати</a>
                                </div>
                            </div>
                            <div class="input_group">
                                <div class="tab_content_item_form_input">
                                    <span class="tab_content_item_form_input_label">Тип металу *</span>
                                    <div class="input_row">
                                        <select class="form_select" v-model="data.material" v-on:change="changeSizeMaterialValue()">
                                            <option :value="null" disabled>Обрати</option>
                                            <option v-for="(n, i) in materials" :key="`value_${i}`" :value="n">{{ n }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab_content_item desctop">
                        <div class="input_groups">
                            <img v-if="!data.material" src="/img/kalkulyator-pidboru-zhorstkoyi-shini.svg" class="trans_img" alt="image">
                            <img v-if="data.material && data.material === 'Алюміній'" src="/img/AL_busbar_300.png" class="trans_img" alt="image">
                            <img v-if="data.material && data.material === 'Алюміній'" src="/img/alumin_width.svg" class="trans_img" alt="image">
                            <img v-if="data.material && data.material === 'Мідь'" src="/img/Cu_busbar_300.png" class="trans_img" alt="image">
                            <img v-if="data.material && data.material === 'Мідь'" src="/img/mid_width.svg" class="trans_img" alt="image">
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="activeTab === 0" class="mobile">
                <a class="view_spec_btn" v-on:click="getProducts()" v-if="data.material && data.power">Підібрати</a>
                <a class="view_spec_btn disabled" disabled v-else>Підібрати</a>
            </div>

            <div v-if="activeTab === 1" class="mobile">
                <a class="view_spec_btn" v-on:click="getProducts()" v-if="data.material && data.width && data.thickness && data.dovzhina">Підібрати</a>
                <a class="view_spec_btn disabled" disabled v-else>Підібрати</a>
            </div>

            <div class="content_tabs params" v-if="products.length">
                <div class="data_content">
                    <div class="tab_content_item left">
                        <span class="tab_content_item_form_input_label">
                            Параметри рекомендованої жорсткої шини для ∆Т=50 °C:
                            <a href="javascript:void(0);" @click="modal_kalk_info = !modal_kalk_info">
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                </svg>
                            </a>
                        </span>
                        
                        <ul class="tab_content_item_info">
                            <li>Сила струму: {{ products[0].nominal_strum }} А</li>
                            <li>Артикул: {{ products[0].product.article }}</li>
                            <li>Розміри:  axb - {{ products[0].width }}х{{ products[0].thickness }} мм</li>
                            <li>Переріз:  {{ products[0].pereriz }} мм²</li>
                            <li>Маса шини довжиною {{ products[0].dovzhina }} мм: {{ products[0].vaga.toFixed(2) }} кг</li>
                            <li>Маса 1 м шини:  {{ ( products[0].vaga / (products[0].dovzhina/1000) ).toFixed(2) }} кг</li>
                            <li>Марка металу: {{ products[0].metal_brand }}</li>
                            <li>Втрати потужності: {{ getPowerLoss(products[0]) }} Вт/м</li>
                        </ul>
                    </div>
                    <div class="tab_content_item">
                        <div class="input_groups">
                            <Line ref="primeChart" :data="chartData" :options="chartOptions" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="content_tabs products" v-if="products.length">
                <span class="tab_content_item_form_input_label">Рекомендована жорстка шина:</span>
                
                <div class="data_content">
                    <div class="table_container">
                        <table class="item_table desctop">
                            <tr class="table_head">
                                <th style="width: 10%;">Артикул</th>
                                <th style="width: 24%;">Найменування</th>
                                <th style="width: 12%;">Запас по струму, %</th>
                                <th style="width: 13%;">Втрати потужності, <br> Вт/м</th>
                                <th style="width: 10%;">Наявність, шт.</th>
                                <th style="width: 13%;">Ціна за 1м шини, <br> грн з ПДВ</th>
                                <th style="width: 13%;">Ціна цільної шини, <br> грн з ПДВ</th>
                                <th style="width: 10%;"></th>
                            </tr>
                            <tr v-for="(product, key) in products" :key="key">
                                <th>{{ product.product.article }}</th>
                                <th><a :href="product.product.tech_char" target="_blank">{{ product.product.name }}</a></th>
                                <th v-if="product.nominal_strum"><span v-if="calculateDifference(product.nominal_strum, data.power)">із {{ calculateDifference(product.nominal_strum, data.power) }}% запасом по струму</span></th>
                                <th v-else><span v-if="calculateDifference(products[0].nominal_strum, data.nominal_strum)">із {{ calculateDifference(products[0].nominal_strum, data.nominal_strum) }}% запасом по струму</span></th>
                                <th>{{ getPowerLoss(product) }}</th>
                                <th><span :class="{in_stock: product.product.balance === 'в наявності', out_of_stock: product.product.balance === 'очікується'}">{{ product.product.balance }}</span></th>
                                <th>{{ product.product.price ? number_format( (product.product.price / (products[0].dovzhina/1000)), 2, ',', ' ') : 'за запитом' }}</th>
                                <th>{{ product.product.price ? number_format(product.product.price, 2, ',', ' ') : 'за запитом' }}</th>
                                <th>
                                    <a class="order_btn" @click.prevent="openOrderModal(product.product)" href="javascript:void(0);">Замовити</a>
                                </th>
                            </tr>
                        </table>

                        <div class="product_accordion">
                            <div class="product_accordion_item" v-for="(product, key) in products" :key="key">
                                <div class="product_accordion_item_header" :class="{active: openProductAccordions.includes(key)}" @click="openProductAccordion(key)">
                                    <div class="product_accordion_item_header_title_container">
                                        <span class="product_accordion_item_header_title">{{ product.product.name }}</span>
                                        <span v-if="product.nominal_strum && calculateDifference(product.nominal_strum, data.power)" class="product_accordion_item_header_sub_title">Запас по струму {{ calculateDifference(product.nominal_strum, data.power) }}%</span>
                                        <span v-else-if="calculateDifference(products[0].nominal_strum, data.nominal_strum)" class="product_accordion_item_header_sub_title">Запас по струму {{ calculateDifference(products[0].nominal_strum, data.nominal_strum) }}%</span>
                                    </div>
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z" fill="#356EEF"/>
                                    </svg>
                                </div>
                                <div class="product_accordion_item_content" v-if="openProductAccordions.includes(key)">
                                    <div class="product_accordion_item_content_row">
                                        <span class="product_accordion_item_content_title">Артикул</span>
                                        <span class="product_accordion_item_content_value">{{ product.product.article }}</span>
                                    </div>
                                    <div class="product_accordion_item_content_row">
                                        <span class="product_accordion_item_content_title">Втрати потужності, Вт/м</span>
                                        <span class="product_accordion_item_content_value">{{ getPowerLoss(product) }}</span>
                                    </div>
                                    <div class="product_accordion_item_content_row">
                                        <span class="product_accordion_item_content_title">Наявність, шт.</span>
                                        <span class="product_accordion_item_content_value">{{ product.product.balance }}</span>
                                    </div>
                                    <div class="product_accordion_item_content_row">
                                        <span class="product_accordion_item_content_title">Ціна за 1м шини, грн з ПДВ</span>
                                        <span class="product_accordion_item_content_value">{{ product.product.price ? number_format( (product.product.price / (products[0].dovzhina/1000)), 2, ',', ' ') : 'за запитом' }}</span>
                                    </div>
                                    <div class="product_accordion_item_content_row">
                                        <span class="product_accordion_item_content_title">Ціна цільної шини, грн з ПДВ</span>
                                        <span class="product_accordion_item_content_value">{{ product.product.price ? number_format(product.product.price, 2, ',', ' ') : 'за запитом' }}</span>
                                    </div>
                                    <div class="product_accordion_item_content_row">
                                        <span class="product_accordion_item_content_title"></span>
                                        <a class="order_btn" @click.prevent="openOrderModal(product.product)" href="javascript:void(0);">Замовити</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <a v-if="data.material && data.material === 'Алюміній'" class="view_spec_btn to_category_btn" target="_blank" href="https://services.vector-vs.com/price-list?category_id=2255">До каталогу жорстких шин</a>
            <a v-if="data.material && data.material === 'Мідь'" class="view_spec_btn to_category_btn" target="_blank" href="https://services.vector-vs.com/price-list?category_id=2250">До каталогу жорстких шин</a>
        </div>


        <div class="overlay" v-if="modal_info || modal_kalk_info || modal_total" v-on:click="closeModals"></div>
        
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg class="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>  
        
        <div class="modal description_modal modal_kalk_info" v-if="modal_kalk_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Пояснення щодо визначення різниці температур ∆Т</p>
                    <svg class="close_modal" v-on:click="modal_kalk_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content">
                    <img src="/img/gnuchka_info.svg" >
                </div>
            </div>
        </div>  

        <div class="modal modal_total" v-if="modal_total">
            <div class="modal_header">
                <p class="modal_header_title">Специфікація</p>
                <svg class="close_modal" v-on:click="() => {modal_total = false; selectedProductAccessories = []; summarize = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="modal_total_content">
                <div class="modal_content">
                    <table class="desctop" style="width:100%; z-index:1;" border=1>
                        <thead>
                            <th class="total_key summ_text">#</th>
                            <th class="total_title summ_text">Найменування</th>
                            <th class="total_maker summ_text">Наявність, шт.</th>
                            <th class="total_count summ_text">Кількість</th>
                            <th class="total_od summ_text">Од. Вим.</th>
                            <th class="total_price center summ_text">Ціна, грн без ПДВ</th>
                            <th class="total_summ center summ_text">Сума, грн без ПДВ</th>
                            <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                            <th class="total_count center summ_text"></th>
                        </thead>
                        <tbody>
                            <tr v-for="(product, i) in selectedProducts" :key="`p_${i}`">
                                <td class="total_key">{{ i + 1 }}</td>
                                <td class="total_title">{{ product.name }}</td>
                                <td class="total_maker">{{ product.balance }}</td>
                                <td class="total_count">
                                    <div class="count">
                                        <a href="javascript:void(0)" v-on:click="minusProductCount(i)">-</a>
                                        <span>{{ product.count }}</span>
                                        <a href="javascript:void(0)" v-on:click="plusProductCount(i)">+</a>
                                    </div>
                                </td>
                                <td class="total_od">шт.</td>
                                <td class="total_price">{{ numberWithSpaces(product.price/1.2) }}</td>
                                <td class="total_summ">{{ numberWithSpaces((product.price/1.2) * 1) }}</td>
                                <td class="total_tech">
                                    <a :href="product.tech_char" target="_blank" v-if="product.tech_char">
                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_1110_5119" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                                        <rect x="0.820312" y="0.5" width="24" height="24" fill="#356EEF"/>
                                        </mask>
                                        <g mask="url(#mask0_1110_5119)">
                                        <path d="M5.82031 21.5C5.27031 21.5 4.79948 21.3042 4.40781 20.9125C4.01615 20.5208 3.82031 20.05 3.82031 19.5V5.5C3.82031 4.95 4.01615 4.47917 4.40781 4.0875C4.79948 3.69583 5.27031 3.5 5.82031 3.5H12.8203V5.5H5.82031V19.5H19.8203V12.5H21.8203V19.5C21.8203 20.05 21.6245 20.5208 21.2328 20.9125C20.8411 21.3042 20.3703 21.5 19.8203 21.5H5.82031ZM10.5203 16.2L9.12031 14.8L18.4203 5.5H14.8203V3.5H21.8203V10.5H19.8203V6.9L10.5203 16.2Z" fill="#356EEF"/>
                                        </g>
                                        </svg>
                                    </a>
                                </td>
                                <td class="total_count">
                                    <a href="#" @click.prevent="deleteProduct(product)">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1080_3575)">
                                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_1080_3575">
                                            <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                <td class="summ_text summ_value">{{ this.summProducts() }}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                <td class="summ_text summ_value">{{ this.pdvProducts() }}</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                <td class="summ_text summ_value">{{ this.summPdvProducts() }}</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="product_accordion">
                        <div class="product_accordion_item" v-for="(product, key) in selectedProducts" :key="key">
                            <div class="product_accordion_item_header active">
                                <div class="product_accordion_item_header_title_container">
                                    <span class="product_accordion_item_header_title">{{ product.name }}</span>
                                    <span v-if="product.nominal_strum && calculateDifference(product.nominal_strum, data.power)" class="product_accordion_item_header_sub_title">Запас по струму {{ calculateDifference(product.nominal_strum, data.power) }}%</span>
                                    <span v-else-if="calculateDifference(products[0].nominal_strum, data.nominal_strum)" class="product_accordion_item_header_sub_title">Запас по струму {{ calculateDifference(products[0].nominal_strum, data.nominal_strum) }}%</span>
                                </div>
                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <div class="product_accordion_item_content">
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Кількість</span>
                                    <span class="product_accordion_item_content_value">
                                        <div class="count">
                                            <a href="javascript:void(0)" v-on:click="minusProductCount(key)">-</a>
                                            <span>{{ product.count }}</span>
                                            <a href="javascript:void(0)" v-on:click="plusProductCount(key)">+</a>
                                        </div>
                                    </span>
                                </div>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Од. Вим.</span>
                                    <span class="product_accordion_item_content_value">шт.</span>
                                </div>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Ціна, грн з ПДВ</span>
                                    <span class="product_accordion_item_content_value">{{ product.price ? number_format(product.price, 2, ',', ' ') : 'за запитом' }}</span>
                                </div>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Наявність, шт.</span>
                                    <span class="product_accordion_item_content_value">{{ product.balance }}</span>
                                </div>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Посилання на тех. хар.</span>
                                    <span class="product_accordion_item_content_value">
                                        <a :href="product.tech_char" target="_blank">
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_1110_5119" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                                            <rect x="0.820312" y="0.5" width="24" height="24" fill="#356EEF"/>
                                            </mask>
                                            <g mask="url(#mask0_1110_5119)">
                                            <path d="M5.82031 21.5C5.27031 21.5 4.79948 21.3042 4.40781 20.9125C4.01615 20.5208 3.82031 20.05 3.82031 19.5V5.5C3.82031 4.95 4.01615 4.47917 4.40781 4.0875C4.79948 3.69583 5.27031 3.5 5.82031 3.5H12.8203V5.5H5.82031V19.5H19.8203V12.5H21.8203V19.5C21.8203 20.05 21.6245 20.5208 21.2328 20.9125C20.8411 21.3042 20.3703 21.5 19.8203 21.5H5.82031ZM10.5203 16.2L9.12031 14.8L18.4203 5.5H14.8203V3.5H21.8203V10.5H19.8203V6.9L10.5203 16.2Z" fill="#356EEF"/>
                                            </g>
                                            </svg>
                                        </a>
                                    </span>
                                </div>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Видалити із замовлення</span>
                                    <span class="product_accordion_item_content_value">
                                        <a href="#" @click.prevent="deleteProduct(product)">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_1080_3575)">
                                                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"/>
                                                </g>
                                                <defs>
                                                <clipPath id="clip0_1080_3575">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                                </defs>
                                            </svg>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="product_accordion_item_content_summ mobile">
                        <div class="product_accordion_item_content_row">
                            <span class="product_accordion_item_content_value">Сума грн без ПДВ</span>
                            <span class="product_accordion_item_content_value">{{ this.summProducts() }}</span>
                        </div>
                        <div class="product_accordion_item_content_row">
                            <span class="product_accordion_item_content_value">ПДВ</span>
                            <span class="product_accordion_item_content_value">{{ this.pdvProducts() }}</span>
                        </div>
                        <div class="product_accordion_item_content_row">
                            <span class="product_accordion_item_content_value">Всього грн з ПДВ</span>
                            <span class="product_accordion_item_content_value">{{ this.summPdvProducts() }}</span>
                        </div>
                    </div>
                </div>
                <div class="modal_bottom">
                    <a href="javascript:void(0)" v-on:click="() => {modal_total = false; selectedProductAccessories = [];}" class="modal_bottom_link">Повернутись в сервіс</a>
                </div>
                <div class="commercial_offer">
                    <div class="commercial_offer_header" @click="is_drop_commercial_offer = !is_drop_commercial_offer">
                        <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                            <g clip-path="url(#clip0_7979_151607)">
                                <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_7979_151607">
                                <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                        <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                        
                        <div class="flex-group customer_info">
                            <div class="flex_form">
                                <div class="flex-row">
                                    <div class="form_grid">
                                        <div class="form_group">
                                            <label class="form_label">Організація</label>
                                            <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                        </div>
                                        <div class="form_group">
                                            <label class="form_label">Контактна особа</label>
                                            <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                        </div>
                                    </div>
                                    <div class="form_grid">
                                        <div class="form_group">
                                            <label class="form_label">Номер телефону *</label>
                                            <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                            <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                        </div>
                                        <div class="form_group">
                                            <label class="form_label">Електронна пошта *</label>
                                            <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                            <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_form">
                                <div class="form_group mr-9">
                                    <label class="form_label">Коментар до замовлення</label>
                                    <div class="textarea_container">
                                        <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                        <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="commercial_offer_order" v-if="commercial_offer_sended">
                            <div class="block_row">
                                <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                                <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                                </svg>
                            </div>
                            <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                            <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                        </div>

                        <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                            <template v-if="is_disable_commercial_offer_btn">
                                Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                            </template>
                            <template v-else>Замовити</template>
                        </a>
                        <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                            Замовити
                        </a>
                    </div>
                </div>

                <template v-if="Object.keys(selectedProductAccessories).length">
                <p class="modal_accessories_title">Рекомендовані аксесуари до шини:</p>
                <table class="desctop accessories" style="width:100%; z-index:1;" border=1>
                    <thead>
                        <th class="total_title summ_text">Найменування</th>
                        <th class="total_count summ_text">Наявність</th>
                        <th class="total_count summ_text">Кількість</th>
                        <th class="total_od summ_text">Од. Вим.</th>
                        <th class="total_price center summ_text">Ціна, грн без ПДВ</th>
                        <th class="total_summ center summ_text">Сума, грн без ПДВ</th>
                        <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                        <th class="total_tech center summ_text"></th>
                    </thead>
                    <tbody>
                        <template v-for="(accessories, group) in selectedProductAccessories" :key="`g_${group}`">
                            <tr class="totat_tr">
                                <td><p class="summ_text">{{ group }}:</p></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr v-for="(product, i) in accessories" :key="`p_${i}`">
                                <td class="total_title">
                                    {{ product.name }}
                                    <div v-if="product.info_items" class="info_blocks">
                                        <div v-for="(info_item, i) in product.info_items" :key="`${i}`" class="info_block">{{ info_item.title }}: {{ info_item.value }}</div>
                                    </div>
                                </td>
                                <td class="total_count">{{ product.balance }}</td>
                                <td class="total_count">
                                    <div class="count">
                                        <a href="javascript:void(0)" v-on:click="minusAccessoryProductCount(group, i)">-</a>
                                        <span>{{ product.count }}</span>
                                        <a href="javascript:void(0)" v-on:click="plusAccessoryProductCount(group, i)">+</a>
                                    </div>
                                </td>
                                <td class="total_od">{{ product.unit }}</td>
                                <td class="total_price">{{ numberWithSpaces(product.price/1.2) }}</td>
                                <td class="total_summ">{{ numberWithSpaces((product.price/1.2) * 1) }}</td>
                                <td class="total_tech">
                                    <a :href="product.tech_char" target="_blank" v-if="product.tech_char">
                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_1110_5119" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                                        <rect x="0.820312" y="0.5" width="24" height="24" fill="#356EEF"/>
                                        </mask>
                                        <g mask="url(#mask0_1110_5119)">
                                        <path d="M5.82031 21.5C5.27031 21.5 4.79948 21.3042 4.40781 20.9125C4.01615 20.5208 3.82031 20.05 3.82031 19.5V5.5C3.82031 4.95 4.01615 4.47917 4.40781 4.0875C4.79948 3.69583 5.27031 3.5 5.82031 3.5H12.8203V5.5H5.82031V19.5H19.8203V12.5H21.8203V19.5C21.8203 20.05 21.6245 20.5208 21.2328 20.9125C20.8411 21.3042 20.3703 21.5 19.8203 21.5H5.82031ZM10.5203 16.2L9.12031 14.8L18.4203 5.5H14.8203V3.5H21.8203V10.5H19.8203V6.9L10.5203 16.2Z" fill="#356EEF"/>
                                        </g>
                                        </svg>
                                    </a>
                                </td>
                                <td class="total_tech">
                                    <button v-if="selectedProducts.some(sp => sp.remote_id === product.remote_id)" @click="addAccessory(product)" class="order_btn active">Додано</button>
                                    <button v-else @click="addAccessory(product)" class="order_btn">Додати</button>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="product_accordion product_accessories">
                    <template v-for="(accessories, group) in selectedProductAccessories" :key="`g_${group}`">
                        <div class="product_accordion_item" v-for="(product, key) in accessories" :key="key">
                            <div class="product_accordion_accessories_header" :class="{active: openProductAccordions.includes(product.remote_id)}" @click="openProductAccordion(product.remote_id)">
                                <div class="product_accordion_item_header_title_container">
                                    <span class="product_accordion_item_header_title">
                                        {{ product.name }}
                                    </span>
                                </div>
                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <div class="product_accordion_item_content" v-if="openProductAccordions.includes(product.remote_id)">
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Ціна, грн.</span>
                                    <span class="product_accordion_item_content_value">{{ product.price }}</span>
                                </div>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Наявність, шт.</span>
                                    <span class="product_accordion_item_content_value">{{ product.balance }}</span>
                                </div>
                                <template v-if="product.info_items">
                                    <div class="product_accordion_item_content_row" v-for="(info_item, i) in product.info_items" :key="`${i}`">
                                        <span class="product_accordion_item_content_title">{{ info_item.title }}</span>
                                        <span class="product_accordion_item_content_value">{{ info_item.value }}</span>
                                    </div>
                                </template>
                                <div class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Посилання на тех. хар.</span>
                                    <span class="product_accordion_item_content_value">
                                        <a :href="product.tech_char" target="_blank" v-if="product.tech_char">
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <mask id="mask0_1110_5119" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                                            <rect x="0.820312" y="0.5" width="24" height="24" fill="#356EEF"/>
                                            </mask>
                                            <g mask="url(#mask0_1110_5119)">
                                            <path d="M5.82031 21.5C5.27031 21.5 4.79948 21.3042 4.40781 20.9125C4.01615 20.5208 3.82031 20.05 3.82031 19.5V5.5C3.82031 4.95 4.01615 4.47917 4.40781 4.0875C4.79948 3.69583 5.27031 3.5 5.82031 3.5H12.8203V5.5H5.82031V19.5H19.8203V12.5H21.8203V19.5C21.8203 20.05 21.6245 20.5208 21.2328 20.9125C20.8411 21.3042 20.3703 21.5 19.8203 21.5H5.82031ZM10.5203 16.2L9.12031 14.8L18.4203 5.5H14.8203V3.5H21.8203V10.5H19.8203V6.9L10.5203 16.2Z" fill="#356EEF"/>
                                            </g>
                                            </svg>
                                        </a>
                                    </span>
                                </div>
                                <div v-if="selectedProducts.some(sp => sp.remote_id === product.remote_id)" class="mobile_acessories_list_item_content_row added">
                                    <div class="acessory_item_added_container">
                                        <span>Додано до специфікації</span>
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12.5" cy="12" r="12" fill="#54D054"/>
                                            <path d="M18 8.5L11 15.4997L7.5 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                <div v-else class="product_accordion_item_content_row">
                                    <span class="product_accordion_item_content_title">Додати до специфікації</span>
                                    <a href="javascript:void(0)" @click.prevent="addAccessory(product)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g clip-path="url(#clip0_7132_41516)">
                                                <path d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#356EEF"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_7132_41516">
                                                <rect width="24" height="24" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                </template>
            </div>
        </div>


    </section>
</template>

<script>
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Tooltip from 'primevue/tooltip';
import ProgressSpinner from 'primevue/progressspinner';
import Toast from 'primevue/toast';
import Breadcrumb from 'primevue/breadcrumb';
import {Link} from '@inertiajs/inertia-vue3';

import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip as ChartTooltip,
  Legend
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  ChartTooltip,
  Legend
)

export default {
    directives: {
        Tooltip,
    },
    props: {
        text: {
            type: String,
            required: false,
        },
        default: {
            type: Number,
            required: false,
        },
        widget: {
            required: false,
        },
        phone: {
            required: false,
        },
        user: {
            required: false,
        },
    },
    components: {
        Toast,
        Line,
        ProgressSpinner,
        Breadcrumb,
        Link,
    },
    layout: CommonLayout,

    data() {
        return {
            activeTab: 0,
            modal_info: false,
            modal_kalk_info: false,
            modal_total: false,
            is_drop_commercial_offer: false,

            summarizeResultPrice: 0,
            pdvResultPrice: 0,
            summPdvResultPrice: 0,

            materials: [],
            min_power: 0,
            max_power: 0,
            widths: [],
            thickneses: [],
            dovzhini: [],

            openProductAccordions: [],

            data: {
                power: null,
                material: 'Мідь',

                width: null,
                thickness: null,
                dovzhina: null,
            },
            products: [],
            selectedProducts: [],
            selectedProductAccessories: [],

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },


            chartData: {
                labels: [20, 30, 40, 50, 60, 70],
            },
            chartOptions: {
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'ΔT (°C)',
                            font: {
                                size: 14
                            }
                        },
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Струм (A)',
                            font: {
                                size: 14
                            }
                        },
                    }
                },
                plugins: {
                    legend: {
                        position: 'top',
                        onClick: null,
                    }
                },
            },

            breadcrumbs: [
                { label: 'Сервіс підбору шин', route: '/kalkulyator-pidboru-shin' },
                { label: 'Підбір жорсткої шини' },
            ]
        }
    },

    created() {
        // this.calculation();
    },

    mounted() {

        this.getData();

        this.$nextTick(function () {
            if (this.widget) {
                let script = document.createElement("script");

                // Add script content
                script.innerHTML = this.widget;

                // Append
                document.head.appendChild(script);
            }
        })
    },

    methods: {
        getPowerLoss(product) {
            // P = I² × (ρ × (1 + α × ΔT) × 1) / S
            // где:
            // P - потери мощности (Вт/м)
            // I - ток (А)
            // ρ - удельное сопротивление (Ом×м)
            // α - температурный коэффициент (1/°C)
            // ΔT - перепад температуры (°C)
            // S - площадь сечения (м²)

            let ρ = 0;
            let α = 0;
            let ΔT = 50;

            if (this.data.material === 'Мідь') {
                ρ = 0.0175 //Медь
                α = 0.004
            }
            if (this.data.material === 'Алюміній') {
                ρ = 0.028 //Алюминий
                α = 0.004
            }

            // I² × (ρ × (1 + α × ΔT) × 1) / S
            return (Math.pow(product.nominal_strum, 2) * (ρ * (1 + α * ΔT) * 1) / product.pereriz).toFixed(2)
        },
        changeValue() {
            this.products = []
            this.selectedProducts = []
            this.getData()
        },
        changeSizeMaterialValue() {
            this.data.power = null
            this.data.width = null
            this.data.thickness = null
            this.data.dovzhina = null

            this.changeSizeValue()
        },
        changeSizeValue() {
            this.products = []
            this.selectedProducts = []
            
            this.payload = true;
            this.error = false;
            axios.post(this.route('api.kalkulyator_pidboru_zhorstkoyi_shini_size_data'), this.data)
                .then((result) => {
                    this.materials = result.data.materials
                    this.widths = result.data.widths
                    this.thickneses = result.data.thickneses
                    this.dovzhini = result.data.dovzhini

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },
        selectTab(i) {
            this.activeTab = i;

            this.data.material = 'Мідь'
            this.data.power = null
            this.data.width = null
            this.data.thickness = null
            this.data.dovzhina = null
            this.products = []
            this.selectedProducts = []

            this.commercial_offer_sended = false
            this.is_disable_commercial_offer_btn = false
        },

        closeModals() {
            this.modal_info = false;
            this.modal_total = false;
            this.modal_kalk_info = false;

            this.selectedProductAccessories = []
        },

        numberWithSpaces(x) {
            // Надёжное округление до 2 знаков, как в PHP round()
            x = Math.round((parseFloat(x) + Number.EPSILON) * 100) / 100;

            // Разделение на целую и дробную часть
            let parts = x.toString().split(".");
            
            // Обеспечим наличие двух цифр после точки
            if (!parts[1]) {
                parts[1] = "00";
            } else if (parts[1].length === 1) {
                parts[1] += "0";
            }

            // Пробелы в целой части
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

            return parts.join(".");
        },


        number_format(number, decimals, dec_point, thousands_sep) {
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },

        getData() {
            if (this.user) {
                this.commercialOfferData.organization = this.user.company
                this.commercialOfferData.name = this.user.name
                this.commercialOfferData.phone = this.user.phone
                this.commercialOfferData.email = this.user.email
            }

            this.payload = true;
            this.error = false;
            axios.post(this.route('api.kalkulyator_pidboru_zhorstkoyi_shini_init_data'), this.data)
                .then((result) => {
                    this.materials = result.data.materials
                    this.min_power = result.data.min_power
                    this.max_power = result.data.max_power
                    this.widths = result.data.widths
                    this.thickneses = result.data.thickneses
                    this.dovzhini = result.data.dovzhini

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        plusProductCount(key) {
            this.selectedProducts[key].count++;

            this.$forceUpdate();
        },

        minusProductCount(key) {
            if (this.selectedProducts[key].count > 1) {
                this.selectedProducts[key].count--
            }

            this.$forceUpdate();
        },

        plusAccessoryProductCount(group, key) {
            this.selectedProductAccessories[group][key].count++;

            this.$forceUpdate();
        },

        minusAccessoryProductCount(group, key) {
            if (this.selectedProductAccessories[group][key].count > 1) {
                this.selectedProductAccessories[group][key].count--
            }

            this.$forceUpdate();
        },

        getProducts() {
            this.payload = true;
            this.error = false;
            axios.post(this.route('api.kalkulyator_pidboru_zhorstkoyi_shini_get_data'), this.data)
                .then((result) => {
                    this.products = result.data.products
                    this.chartData.datasets = [
                        {
                            label: 'Допустимий струм',
                            data: result.data.chartDataY,
                            borderColor: '#36A2EB',
                            backgroundColor: '#36A2EB',
                            pointRadius: 4,
                            pointBackgroundColor: '#FFF',
                            tension: 0.3
                        }
                    ];

                    if (!this.products.length) {
                        this.$toast.add({ severity: 'info', summary: 'Немає результатів', detail: '', life: 3000 });
                    }

                    this.payload = false;
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        getExcel() {
            axios.post(this.route('api.calculator_get_excel'), {
                tabs: this.tabs,
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        openOrderModal(product) {
            this.selectedProducts = []
            this.selectedProducts.push(product)

            this.modal_total = true

            this.selectedProductAccessories = []
            axios.post(this.route('api.kalkulyator_pidboru_zhorstkoyi_shini.get_accessories'), {items: this.selectedProducts})
                .then((result) => {
                    this.selectedProductAccessories = result.data.data
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },

        addAccessory(product) {
            if (this.selectedProducts.some(sp => sp.remote_id === product.remote_id)) {
                const index = this.selectedProducts.findIndex(sp => sp.remote_id === product.remote_id);
                if (index !== -1) {
                    this.selectedProducts.splice(index, 1);
                }
            } else {
                this.selectedProducts.push(product)
            }
        },

        deleteProduct(product) {
            if (this.selectedProducts.some(sp => sp.remote_id === product.remote_id)) {
                const index = this.selectedProducts.findIndex(sp => sp.remote_id === product.remote_id);
                if (index !== -1) {
                    this.selectedProducts.splice(index, 1);
                }
            }
        },

        openProductAccordion(key) {
            if (this.openProductAccordions.includes(key)) {
                let index = this.openProductAccordions.indexOf(key);
                if (index !== -1) {
                    this.openProductAccordions.splice(index, 1);
                }
            } else {
                this.openProductAccordions.push(key)
            }
        },

        calculateDifference(num1, num2) {
            if (num1 === 0 || !num2) {
                return 0;
            }
            const difference = ((num1 - num2) / num2) * 100;
            if (difference.toFixed(0) > 0) {
                return difference.toFixed()
            }

            return 0;
        },

        summProducts() {
            let summ = 0;
            
            this.selectedProducts.forEach((value, index) => {
                summ += value.count * (value.price/1.2);
            });

            return this.numberWithSpaces(summ);
        },
        pdvProducts() {
            let summ = 0;
            let pdv = 0;
            
            this.selectedProducts.forEach((value, index) => {
                summ += value.count * (value.price/1.2);
            });

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(pdv);
        },
        summPdvProducts() {
            let summ = 0;
            let pdv = 0;
            
            this.selectedProducts.forEach((value, index) => {
                summ += value.count * (value.price/1.2);
            });

            summ = Math.round((parseFloat(summ) + Number.EPSILON) * 100) / 100;

            pdv = (summ * 20) / 100;

            pdv = Math.round((parseFloat(pdv) + Number.EPSILON) * 100) / 100;

            return this.numberWithSpaces(summ + pdv);
        },

        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'KalkulyatorShini',
                    items: this.selectedProducts,
                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: this.summPdvProducts(),
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }
    }
};
</script>

<style scoped>
a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 10px 25px 0 20px;
}
.service_header {
    display: flex;
    justify-content: space-between;
}
.service_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.modal_accessories_title {
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0%;
    color: #212529;
    margin: 0px;
    margin-top: 34px;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 651px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

.close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.modal_kalk_info .modal_content {
    text-align: center;
}

.add_item_modal {
    width: 92%;
}

.add_item_modal .modal_header {
    border-bottom: none;
}

.add_item_modal .modal_header_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.trans_img {
    width: auto;
    height: 150px;
}

.mobile {
    display: none;
}

@media (max-width: 1000px) {
    .modal {
        width: 100%;
    }
    .container {
        padding: 10px 0 0 0;
    }
    .service_header {
        flex-direction: column;
    }
    .input_group, .form_input, .nominal_select{
        width: 100%!important;
    }
    .graphic_block {
        align-items: center!important;
    }
    .trans_img {
        width: 200px;
        height: auto;
    }
    .content_tab span {
        width: 100%!important;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 1.2em;
        white-space: nowrap;
    }
    .edit_title_container {
        flex-direction: column;
    }
    .edit_title_input {
        width: auto!important;
    }
    .info_block {
        width: 100%;
    }
    .data_content {
        flex-direction: column;
    }
}

@media (max-width: 470px) {
    .desctop {
        display: none;
    }
    .mobile {
        display: block;
    }
    .info_btn {
        display: none;
    }
    .service_title {
        font-size: 27px;
        line-height: 36px;
    }
    .input_groups {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start!important;
    }
    .tabs {
        margin-top: 30px;
    }
    .to_category_btn {
        max-width: 100%!important;
        margin-left: 0px!important;
    }
    .content_tabs.main, .content_tabs.params {
        border: none!important;
        padding: 0px!important;
    }

    .content_tabs.products {
        padding: 8px!important;
    }

    .content_tabs {
        margin-top: 30px!important;
    }

    .trans_img {
        width: 100%;
        height: auto;
    }

    .order_btn {
        width: 100px!important;
        height: 36px;
        display: flex!important;
        align-items: center;
        justify-content: center;
    }

    .tab_content_item_form_input_label {
        margin-bottom: 12px!important;
    }

    .product_accordion {
        display: flex!important;
    }

    .modal_total .modal_content {
        height: auto!important;
        max-height: unset!important;
    }

    .product_accordion_item_content_value .count {
        gap: 15px!important;
    }
    .count a {
        font-size: 25px!important;
    }
    .content_tab-item {
        padding: 11px 12px!important;
    }
}

@media (max-width: 395px) {
    .content_tab {
        font-size: 14px!important;
    }
    .content_tab-item {
        padding: 11px 3px!important;
    }
}

.top_bar {
    margin-top: 80px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.top_bar .top_bar_title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.top_bar .add_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 251px;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
}

.main_table {
    width:100%;
    border-radius: 4px 4px 0px 0px;
}

.main_table, th, td {
  border: 1px solid #DEE2E6;
  border-collapse: collapse;
}

.main_table_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--body-text-body-color, #212529);
    height: 60px;
    background: #E3F1FF;
    overflow-wrap: break-word;
    padding: 5px;
}

.main_table_row {
    height: 53px;
}

.main_table_count_input {
    width: 60px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #DEE2E6;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}

.edit_row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 10px;
}

.total_btns {
    display: flex;
    gap: 26px;
}

.view_spec_btn {
    width: 100%;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.mobile .view_spec_btn {
    margin-top: 24px;
}

.view_spec_btn.disabled {
    background: #DEE2E6;
    color: #6C757D;
}

.download_spec {
    width: 323px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.download_spec.disabled {
    color: #6C757D;
}

.subtitle {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
}

.form_row {
    display: flex;
    gap: 100px;
}

.input_group {
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
}

.form_input_item {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.form_input_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}

.form_input {
    width: 100%;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 10px 16px;
}
.form_select {
    padding: 10px 16px;
    width: 306px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    display: flex;
    align-items: center;
}

.table_select {
    width: 100%;
    padding-left: 10px;
    padding-right: 30px;
    border: none;
    outline: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    cursor: pointer;
}

.form_border {
    border: 1px solid rgba(206, 212, 218, 0.4);
    border-radius: 4px;
    padding: 12px;
    margin-top: 20px;
}

.checkbox_input {
    padding: 0;
    margin: 0;
    margin-right: 9px;
}

.form_border .input_group {
    margin-top: 24px;
}

.line_table {
    margin-top: 30px;
}

.line_table select {
    padding-right: 40px;
}

.line_table thead th {
    height: 72px!important;
}

.line_table tbody tr {
    height: 55px!important;
}

.line_table table {
    table-layout:fixed;
}

.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}


table {
  margin: 0 auto;
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}
table thead th,
table tfoot th {
  text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
table caption {
  padding:.5em;
}
table th,
table td {
    border: 1px solid #DEE2E6;
}

.delete_td {
    padding: 22px 10px 24px 20px;
}

.add_btn {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 16px;
}

.option_select {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    background-color: #FFFFFF;

    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    width: 100%;
}

.count_td {
    padding: 10px 22px 10px 0px;
}

.count_td .count span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}

.count_td .count a {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #000000;
}

.count a {
    color: #000000;
    font-size: 18px;
}

.ol_num {
    width: 50px;
    text-align: center;
}

.ol_eq {
    width: 288px;
    max-width: 288px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_eq__select {
    width: 240px;
    max-width: 240px;
}

.ol_p_ctn {
    width: 217px;
    max-width: 217px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_p_ctn__select {
    width: 174px;
    max-width: 174px;
}

.ol_char {
    width: 205px;
    max-width: 205px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_char__select {
    width: 166px;
    max-width: 166px;
}

.ol_curr {
    width: 189px;
    max-width: 189px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_curr__select {
    width: 148px;
    max-width: 148px;
}

.ol_cnt {
    width: 128px;
    padding-left: 22px;
}

.ol_article {
    width: 172px;
    max-width: 172px;
    padding-left: 22px;
}

.ol_close {
    width: 46px;
    padding-left: 16px;
}

.summ_point {
    height: 44px;
    text-align: flex-end;
    padding-right: 22px;
}

.summ_value {
    text-align: center;
    padding-right: 22px;
}

.variation_table {
    padding-top: 70px;
}

.variation_table_footer {
    padding-left: 42px;
    padding-right: 42px;
    display: flex;
    justify-content: space-between;
}
.module_ctn_container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.module_ctn {
    display: flex;
    align-items: center;
    gap: 10px;
}
.module_ctn_title {
    margin: 0px;
    padding: 0px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
}
.module_ctn_input {
    width: 86px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #000000;
}
.btn_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
}
.border-danger {
    border: 1px solid red;
    color: red;
}
.error_text {
    color: red;
}
.modal_total {
    width: 90%;
    top: 435px;
    max-width: 1296px;
    overflow: hidden;
}

.modal_total_content {
    height: 80vh;
    overflow: auto;
}

.modal_total .modal_content{
    overflow: auto;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
    margin-bottom: 10px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.bottom_row {
    display: flex;
    width: 100%;
    align-items: flex-end;
    padding-top: 40px;
}

.bottom_row_block {
    display: flex;
    width: 100%;
    align-items: flex-end;
    align-items: baseline;
}

.nominal_select {
    padding: 12px 16px;
    width: 160px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.metal_constr_select {
    width: 260px;
    padding-right: 40px;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 38px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_maker {
    width: 62px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_summ {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 38px;
}
.center {
    text-align: center;
    height: 38px;
}
.totat_tr {
    height: 38px;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.form_radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.selected_value {
    margin-left: 18px;
    font-weight: 400;
    cursor: pointer;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}

.product_media_modal .modal_content {
    max-height: 70vh;
    margin-top: 0px;
}
.product_media_modal {
    padding: 0px;
    z-index: 10000!important;
}
.product_media_modal #close_modal{
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
}
.warning_popup #close_modal{
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 1;
}

.warning_popup {
    z-index: 100000;
}

.warning_popup h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
}

.warning_popup .confir_btn_group {
    display: flex;
    justify-content: left;
    gap: 15px;
    padding: 10px 0px;
}

.warning_popup .edit_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #356EEF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.warning_popup .confirm_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: #FFFFFF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6C757D;
    padding-left: 30px;
    padding-right: 30px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
}

.block_images {
    display: flex;
    gap: 20px;
}

.sub_images {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 200px;
    overflow: auto;
}

.product_media_modal_sub_images {
    width: 100%;
    display: flex;
    gap: 17px;
    overflow: auto;
    padding: 5px 10px 0px 10px;
    margin-bottom: 10px;
}

.product_img {
    width: 55px;
    height: auto;
    cursor: pointer;
}

.product_media_modal_img {
    width: 48px;
    height: 48px;
    cursor: pointer;
}

.main_img_container {
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 180px;
}
.main_img_container svg {
    position: absolute;
    bottom: 8px;
    right: 8px;
    cursor: pointer;
}

.product_info_text {
    margin: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    margin-top: 10px;
}

.product-item.active {
    background-color: #C8E4FF;
}
.product_img.active {
    border: 1px solid #C8E4FF;
}
.product_media_modal_img.active {
    border: 1px solid #C8E4FF;
}
.product_video_iframe {
    pointer-events: none;
}

.product_media_modal_main_img {
    width: auto;
    height: auto;
    max-height: 250px;
}

.product_media_modal_description {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.nominal_power, .row_item {
    width: 100%;
}

.product_media_modal_main_img_container {
    position: relative;
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 30px;
}
.product_media_modal_row {
    display: flex;
    gap: 10px;
}
.product_media_modal_main_img_container .group_btns {
    display: flex;
    gap: 30px;
    position: absolute;
    bottom: 20px;
    right: 20px;
}

.zindexed {
    z-index: 9999!important;
}

#addMoadal {
    max-height: 70vh;
}

.input-disabled {
    color: #6C757D!important;
}

.form_input_item_checkbox {
    display: flex;
}

.select_container {
    position: relative;
}

.select_container .clear_icon {
    position: absolute;
    top: 17px;
    right: 35px;
    cursor: pointer;
}

.form_input_title_row {
    display: flex;
    justify-content: space-between;
}

.accountings_type_file_link {
    font-size: 12px;
    color: #356EEF;
    text-decoration: underline;
}

.non_selected {
    color: #6C757D!important;
}

.add_item_modal .info_form {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.graphic_info_title_bold.price_row {
    text-wrap: nowrap;
    white-space: nowrap;
}

@media (max-width: 1120px) {
    .bottom_row {
        align-items: flex-start;
        flex-direction: column;
        gap: 40px;
    }
    .row_item, .bottom_row_block {
        width: auto;
    }
    .bottom_row_block {
        gap: 50px;
    }

    .tab_content {
        flex-direction: column;
    }

    .tab_content_item {
        width: 100%!important;
    }

    .form_select {
        width: 100%!important;
    }

    .tabs {
        width: 100vw;
        overflow: auto;
    }

    .content_tab-item {
        width: 100%!important;
        text-align: center;
    }
}

@media (max-width: 960px) {
    .product_media_modal_main_img {
        width: 100%;
        height: auto;
        max-height: 100%;
    }
    .product_media_modal_row {
        flex-direction: column;
    }
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .add_item_modal .btn_container {
        justify-content: start;
    }
    .info_block {
        padding: 0px!important;
    }
}

@media (max-width: 920px) {
    .table_container {
        width: 100%;
        overflow: auto;
    }
    .service_header {
        flex-direction: column;
    }
    .top_bar {
        flex-direction: column;
        justify-content: start;
        align-items: baseline;
    }
    .main_table_title {
        min-width: 120px;
    }

    .add_item_modal .input_group {
        flex-direction: column;
    }

    .add_item_modal .form_row {
        flex-direction: column;
        align-items: center;
    }

    .add_item_modal .info_form {
        width: 100%;
    }

    .add_item_modal .form_input {
        width: 100%;
    }

    .add_item_modal .form_input_item {
        width: 100%;
    }

    .add_item_modal .form_select {
        width: 100%;
    }

    .add_item_modal .line_table {
        overflow: auto;
    }

    .add_item_modal .line_table thead th {
        min-width: 120px;
    }
    .modal_total .modal_bottom {
        flex-direction: column;
        gap: 20px;
    }

    .notification_bar {
        right: 10px!important;
        padding: 20px 20px!important;
        font-size: 12px!important;
    }
}

@media (max-width: 680px) {
    .notification_bar {
        right: 5px!important;
        padding: 12px 20px!important;
        font-size: 12px!important;
        line-height: 84%!important;
        height: auto!important;
    }
    .notification_bar span {
        gap: 9px;
        flex-direction: column;
        text-align: center;
    }
    .total_btns {
        flex-direction: column;
        width: 100%;
    }
    .view_spec_btn, .download_spec, .metal_constr_select, .bottom_row_block {
        width: 100%;
    }
    .metal_constr_select {
        padding-right: 0px;
    }
    .bottom_row_block {
        flex-direction: column;
        gap: 20px;
    }
    .result_list {
        height: auto!important;
        overflow: auto!important;
    }
    .row_block {
        width: 100%;
    }
}

@media (max-width: 450px) {
    .modal_total {
        top: 350px;
    }
    .modal_total_content {
        height: 655px;
    }
    .modal_total .modal_bottom__btns {
        flex-direction: column;
    }
    .modal_total .avr_summ_btn {
        width: 100%;
    }
    .modal_total .avr_excel_btn {
        width: 100%;
    }
}

@media (max-width: 400px) {
    .modal_total_content {
        height: 666px;
    }
}

@media (max-width: 390px) {
    .modal_total_content {
        height: 330px;
    }
}

@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .total_btns {
        justify-content: space-between;
        width: 100%;
    }
}

@media screen and (min-width: 1900px){
    .add_item_modal {
        width: auto;
    }
}

@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column!important;
    }
    .form_input {
        width: 100%!important;
    }
}
@media (max-width: 600px) {
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%!important;
    }
}

.notification_bar {
    width: auto;
    padding: 20px 25px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 63px;
    right: 125px;
    border-radius: 4px;
    background: #6C99FF;
    box-shadow: -2px 4px 16px 0px rgba(0, 0, 0, 0.15);
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    z-index: 999;
}

.notification_bar.error {
    background: #ff5757;
}

.notification_bar.error svg path {
    fill: #FFFFFF;
}

.notification_bar span {
    display: flex;
    align-items: center;
    gap: 10px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

tr.errors {
    border: 2px solid red;
}
.custom_select {
    position: relative;
}
.custom_select_dropdown {
    position: absolute;
    top: 33px;
    left: 0;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #CED4DA;
    background: #FFF;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.10);
    z-index: 2;
    padding: 0;
    width: 100%;
    max-height: 300px;
    overflow: auto;
}

.custom_select_dropdown li {
    list-style: none;
    border-top: 1px solid #CED4DA;
}

.custom_select_children:hover, .custom_select_row:hover {
    background: #E9F4FF;
    cursor: pointer;
}

.custom_select_children.active {
    background: #E9F4FF;
    cursor: pointer;
}

.custom_select_children input {
    display: none;
}

.custom_select_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 8px 8px 10px;
}

.custom_select_row input {
    display: none;
}

.custom_select_children {
    padding: 8px 8px 8px 25px;
    border-top: 1px solid #CED4DA;
}

.custom_select_childrens {
    padding: 0;
    display: flex;
    flex-direction: column;
}

.custom_select {
    cursor: pointer;
}

.d-none {
    display: none;
}

.select_item_btn {
    display: flex;
    width: 79px;
    height: 27px;
    padding: 3px 6px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: var(--Systemblue, #356EEF);
    color: var(--SystemWhite, #FFF);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

select:disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

input:disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

.top_panel {
    display: flex;
    gap: 10px;
    align-items: center;
}
.tabs {
    display: flex;
    align-items: center;
    overflow: auto;
}
.content_tab {
    border-bottom: 2px solid var(--border-border-subtle-01, #C6C6C6);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 11px 16px;
    color: var(--text-text-secondary, var(--text-text-secondary, #525252));
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.16px;
}
.content_tab.active {
    color: #161616;
    border-bottom: 2px solid var(--border-border-interactive, #0F62FE);
    background: var(--transparent-transparent, #FFF);
    background-blend-mode: multiply;
}
.content_tab-item {
    font-weight: 600;
    width: 318px;
    justify-content: center;
}
.tab_content_item_form_input_label {
    display: block;
    color: #000;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 8px;
}
.project_name_subtitle {
    color: #525252;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 20px;
}
.project_name {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 12px;
}
.input_row {
    display: flex;
    align-items: center;
    gap: 8px;
}
.input_groups {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    padding-top: 24px;
    align-items: center;
    justify-content: center;
}
.graphic_block.input_groups {
    justify-content: left;
    gap: 40px;
}
.tab_content {
    display: flex;
    justify-content: space-between;
}
.data_content {
    display: flex;
    justify-content: space-between;
}
.tab_content_item {
    width: 636px;
    border-radius: 8px;
}
.tab_content_item.left .input_groups {
    align-items: baseline;
}
.graphic_info_title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.2px;
    display: flex;
    gap: 5px;
    align-items: center;
}
.graphic_info_title a{
    display: flex;
}
.graphic_info_title_bold {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19.2px;
}
.graphic_info_row .graphic_info_title {
    margin-bottom: 1rem;
}
.graphic_info_row {
    display: flex;
    gap: 20px; 
    justify-content: space-between;
}
.graphic_info {
    border-bottom: 1px solid #D9D9D9;
    margin-bottom: 10px;
}
.graphic_block {
    padding-bottom: 28px;
    border-bottom: 1px solid #D9D9D9;
    margin-bottom: 10px;
}
.row_block {
    position: relative;
}
.warning_text {
    display: block;
    position: absolute;
    bottom: 0px;
    color: #B70D09;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
}
.warning_text.var10 {
    bottom: auto;
}
.graphic_info_title_bold.warning {
    border-radius: 4px;
    background: #F1A5A3;
    padding: 4px 12px;
    height: 100%;
}
.result_list {
    height: 185px;
    overflow: auto;
}
.edit_title_container {
    display: flex;
    gap: 10px;
}
.edit_title_container_btns {
    display: flex;
    gap: 10px; 
}
.edit_title_input {
    border-radius: 4px;
    border: 1px solid #356EEF;
    width: 350px;
    padding: 0px 6px;
    height: 30px;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.save_title_btn {
    width: 85px;
    height: 30px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}
.cancel_title_btn {
    width: 85px;
    height: 30px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}
.title_edited {
    width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.title_edited:hover {
    border-radius: 4px;
    background: #F5F6F8;
}
.project_name_editable {
    cursor: pointer;
}
.delete_icon {
    display: flex;
}
.content_tab span {
    max-width: 318px;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 1.2em;
    text-wrap: nowrap;
}

.form_input.var10:disabled {
    filter: opacity(1);
}

.var10.warning {
    border: 1px solid red;
}

.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.modal_confirm_content {
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28.8px;
    margin-bottom: 30px;
}
.modal_confirm .modal_header {
    border: none;
}
.contact {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
}
.contact p {
    margin: 0px;
}
.summ_btn {
    margin-top: 24px;
}
.content_tabs {
    border: 1px solid #E5E5E5;
    border-radius: 12px;
    padding: 12px;
    margin-top: 45px;
}
.content_tabs.params, .content_tabs.products {
    margin-top: 16px;
}
.to_category_btn {
    width: 100%;
    max-width: 306px;
    margin-top: 30px;
    margin-left: 12px;
}
.tab_content_item_info {
    padding: 0px;
}
.tab_content_item_info li {
    list-style: none;
    padding-bottom: 9px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #000000;
}
.item_table {
        border-collapse: collapse;
        width: 100%;
    }

    .item_table td, .item_table th {
        border: 1px solid #ddd;
        padding: 8px;
    }

    .item_table th a {
        color: #495057;
    }
    .item_table th a:hover {
        color: #2196F3;
    }
    .item_table tr {
        line-height: 13px;
    }

    .item_table tr:hover {background-color: #eef7ff;}

    .item_table tr.table_head {
        background-color: #f8f9fa;
        height: 63px;
    }
    .item_table tr.table_head th {
        font-weight: 700;
    }
    .item_table tr th {
        font-weight: normal;
        height: 39px;
    }
    .item_table th {
        text-align: left;
        color: #495057;
        font-size: 0.8rem;
    }
    .table_container {
        width: 100%;
    }

    .order_btn {
        display: block;
        width: 84px;
        padding: 2px 8px 2px 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF !important;
        background: #356EEF;
        border: 1px solid #356EEF;
        cursor: pointer;
    }

    .modal_total .order_btn {
        display: block;
        width: 84px;
        padding: 2px 8px 2px 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        cursor: pointer;
        border: 1px solid #356EEF;
        color: #356EEF !important;
        background: #FFFFFF;
    }
    
    .order_btn.active {
        border: 1px solid #34C759;
        color: #34C759 !important;
        background: #FFFFFF;
    }


.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.commercial_offer_body .form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.commercial_offer_body .form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.commercial_offer_body .form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.commercial_offer_body .form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 100%;
    height: 100%;
}
.error_text {
    color: red;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.commercial_offer_order_text {
    margin-top: 12px;
}

.product_accordion {
    display: none;
    flex-direction: column;
    gap: 16px;
}

.product_accordion.product_accessories {
    padding-top: 10px;
}

.product_accordion.product_accessories .product_accordion_item{
    border: 1px solid #F5F5F5;
    border-radius: 5px;
    padding: 4px;
}

.product_accordion_item_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-radius: 4px;
    background: #E6F3FF;
    color: #000000;
    border-bottom: 1px solid #0000001A;
    background: #F5F5F5;
}
.product_accordion_accessories_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000000;
}
.product_accordion_item_header svg, .product_accordion_accessories_header svg{
    min-width: 24px;
}

.product_accordion_item_header.active, .product_accordion_accessories_header.active {
    background: #F5F5F5;
    padding: 4px;
}
.product_accordion_item_header.active svg, .product_accordion_accessories_header.active svg {
    rotate: 180deg;
}
.product_accordion.product_accessories .product_accordion_item_header_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.product_accordion_item_header_title {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;
}
.product_accordion_item_header_title_container {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.product_accordion_item_header_sub_title {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
}
.product_accordion_item_content {
    margin-bottom: 24px;
}
.product_accordion_item_content_row {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
}
.product_accordion_item_content_title {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #212529;
}
.product_accordion_item_content_value {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    color: #000000;
    text-align: right;
}
.product_accordion_item_content_value .count {
    gap: 8px;
    font-weight: 500;
}
.product_accordion_item_content_summ {
    border-top: 1px solid #C8E4FF;
}
.tooltip {
    cursor: pointer;
}
.mobile_acessories_list_item_content_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;
        margin-bottom: 12px;
    }
    .mobile_acessories_list_item_content_row .main_table_count_input {
        font-weight: 700;
    }
    .mobile_acessories_list_item_content_row.active {
        background: #EFF4FE;
    }
    .mobile_acessories_list_item_content_row.added {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--body-text-body-color, #212529);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        background: #EFF4FE;
    }
    .acessory_item_added_container {
        display: flex;
        padding: 4px;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }

    .info_blocks {
        display: flex;
        gap: 4px;
        padding-top: 5px;
    }

    .info_block {
        height: 14px;
        border-radius: 8px;
        background-color: #E6E6E680;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        vertical-align: middle;
        padding: 4px 7px;
        display: flex;
        align-items: center;
    }

    table.accessories tr td {
        padding: 6px 0;
    }
</style>
